import { MealTime } from "@/clients/models/MealTime";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetCandidates = (mealTime: MealTime) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.GO_TO_CANDIDATE, mealTime],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealsService.getAllGotoCandidatesApiV1MealsGotoCandidatesGet(
          user.id,
        );
      return data;
    },
  });
  return {
    candidates: data,
    isLoading,
    error,
  };
};
